import { useEffect, useState } from 'react';
import queryString from 'query-string';
import { useAuthentication } from '../Providers/AuthenticationProvider';

export const useLogOutCurrentUser = () => {
  const { logoutWithRedirect } = useAuthentication();

  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    const search = window.location.search;
    const parsed = queryString.parse(search);
    const returnFromLogout = parsed?.returnFromLogout;

    if (returnFromLogout === 'true') {
      setIsLoggedOut(true);
      return;
    }

    const returnFromLogoutParam = 'returnFromLogout=true';

    const finalSearch = search ? `${search}&${returnFromLogoutParam}` : `?${returnFromLogoutParam}`;

    sessionStorage.setItem('redirectAfterLogout', `${window.location.pathname}${finalSearch}${window.location.hash}`);
    logoutWithRedirect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isLoggedOut;
};
